export default {
  install (Vue, options) {
    let local = {}

    local.getRoute = (name) => {
      return { name: name }
    }

    Vue.prototype.$local = local
  }
}
